module.exports = __webpack_public_path__ + "img/about-values-01.jpg?d8ed15f98172c0ddcf4bce0ce675024e";